type HexColor = `#${string}`;

interface ColorSelector {
  obtenerColor: () => HexColor;
  devolverColor: (color: HexColor) => void;
  disponibles: () => number;
}

function hslToHex(h: number, s: number, l: number): HexColor {
  s /= 100;
  l /= 100;

  const k = (n: number) => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);

  const f = (n: number) => {
    const color = l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, "0");
  };

  return `#${f(0)}${f(8)}${f(4)}` as HexColor;
}

export function crearSelectorColores(cantidad: number): ColorSelector {
  const colores: HexColor[] = [];

  let hue = Math.random() * 360; // punto inicial aleatorio
  const goldenAngle = 137.508;   // 🔥 clave

  for (let i = 0; i < cantidad; i++) {
    hue = (hue + goldenAngle) % 360;

    const sat = 70;   // fija para consistencia
    const light = 50; // evita muy claros/oscuros

    colores.push(hslToHex(hue, sat, light));
  }

  return {
    obtenerColor: (): HexColor => {
      if (!colores.length) {
        throw new Error("No hay más colores disponibles");
      }

      // 👇 IMPORTANTE: NO random
      return colores.shift()!; // ordenado = mejor separación visual
    },

    devolverColor: (color: HexColor): void => {
      colores.push(color);
    },

    disponibles: (): number => colores.length
  };
}